<dialog-gala (clickClose)="hideModal()">
  <span gala-dialog-titre>{{lgTrad.MODIF}}</span>
  @if (sessionIncarnee) {
    <div class="text-center mb-3">
      <span class="badge badge-warning mr-2">{{lgTrad.MODESUPERVISEUR}}</span>
      <span class="small">{{lgTrad.COMPTEVERROUILLE}}</span>
    </div>
  }
  <accordion-gala [multiple]="true">
    <accordion-gala-item [collapsed]="false">
      <accordion-gala-item-head>{{lgTrad.GENEDATAS}}</accordion-gala-item-head>
      <accordion-gala-item-body>
        <form [formGroup]="formData" autocomplete="off">
          <div class="row">
            <div class="col-6">
              <select-gala formControlName="CIVILITE" [label]="lgTrad.CIVILITY" [options]="listeCIVILE"
                bindLabel="LIB" bindValue="ID" />
              </div>
              <div class="col-6">
                <select-gala (selected)="onChangePays($event)" [searchable]="true"
                  formControlName="CODEPAYS" [options]="listePAYS" bindLabel="LIBELO" bindValue="COPAIP"
                  [label]="lgTrad.COUNTRY" />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <input-gala formControlName="NOM" [label]="lgTrad.NAME" class="uppercase" />
                </div>
                <div class="col-6">
                  <input-gala formControlName="PRENOM" [label]="lgTrad.SURNAME" />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <input-gala formControlName="ADRESSEA" [placeholder]="lgTrad.ADRESSE"
                    [label]="lgTrad.ADRESSE" />
                  </div>
                  <div class="col-12">
                    <input-gala formControlName="ADRESSEB" [placeholder]="lgTrad.COMPLEMENT"
                      [label]="lgTrad.COMPLEMENT" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <input-gala formControlName="MAIL" [placeholder]="lgTrad.MAIL"
                        [label]="lgTrad.MAIL" />
                      </div>
                    </div>
                    <app-commune container="#modalDetails" #communeGala [formData]="formData" />
                    <div class="row">
                      <select-phone container="#modalDetails" class="col" [formData]="formData" typtel="TYPTEL1"
                        indic="INDICATIF1" tel="TEL1" [optionsTypeTel]="listeTYPETEL" bindLabelTypeTel="LIB"
                        bindValueTypeTel="ID" />
                        <select-phone container="#modalDetails" class="col" [formData]="formData" typtel="TYPTEL2"
                          indic="INDICATIF2" tel="TEL2" [optionsTypeTel]="listeTYPETEL" bindLabelTypeTel="LIB"
                          bindValueTypeTel="ID" />
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <date-gala [label]="lgTrad.DEBUT" [value]="DDebut" />
                          </div>
                          <div class="col-6">
                            <date-gala [label]="lgTrad.FIN" [value]="DFin" />
                          </div>
                        </div>
                      </form>
                    </accordion-gala-item-body>
                  </accordion-gala-item>
                  <accordion-gala-item [collapsed]="false">
                    <accordion-gala-item-head>{{lgTrad.RIGHTS}}</accordion-gala-item-head>
                    <accordion-gala-item-body>
                      @if (formData && this.user.TYPEUTIL) {
                        <form [formGroup]="formData" autocomplete="off">
                          <div class="container">
                            <div class="row">
                              <div class="col-6">
                                <table class="table">
                                  <thead class="bg-primary">
                                    <tr>
                                      <th colspan="2">{{lgTrad.APPLICATIF}}</th>
                                      <th colspan="2">{{lgTrad.PROFIL}}</th>
                                      <th colspan="2"></th>
                                    </tr>
                                  </thead>
                                  @for (prof of user.PROFILS; track prof) {
                                    <tbody>
                                      <tr>
                                        <td colspan="2" class="text-left">{{prof.NOMAPP}}</td>
                                        <td colspan="2" class="text-left">{{prof.PROFIL}}</td>
                                        <td colspan="2"></td>
                                      </tr>
                                    </tbody>
                                  }
                                </table>
                              </div>
                              <div class="col-6 pt-2">
                                <input-gala [longlabel]="true" formControlName="LOGIN" [label]="lgTrad.LOGIN"
                                  class="uppercase" autocomplete="off" />
                                @if (keycloakAuth.actif) {
                                  <div class="d-flex align-items-center justify-content-center mt-3">
                                    <button mat-stroked-button type="button" color="primary" [disabled]="sessionIncarnee"
                                      (click)="modifierMotDePasse()">{{lgTrad.MDPKEYCLOAK}}</button>
                                    @if (sessionIncarnee) {
                                      <div class="bulle-superviseur ml-3">
                                        <span class="badge badge-warning mb-1">{{lgTrad.MODESUPERVISEUR}}</span>
                                        <div>{{lgTrad.MDPKEYCLOAKSUPERVISEUR}}</div>
                                      </div>
                                    }
                                  </div>
                                } @else {
                                  <input-gala [longlabel]="true" type="password" formControlName="PWDOLD"
                                    [label]="lgTrad.PWDOLD" autocomplete="new-password" />
                                  <input-gala [longlabel]="true" type="password" formControlName="PWD1"
                                    placeholder="{{lgTrad.CHGPWD}}" [label]="lgTrad.PWD1" (change)="checkNewPWD('PWD1')"
                                    [ngClass]="{'pwd-OK': classPwdCtrl === 'OK', 'pwd-error': classPwdCtrl === 'ERR'}" />
                                  <input-gala [longlabel]="true" type="password" formControlName="PWD2"
                                    placeholder="{{lgTrad.CTRLNEWPWD}}" [label]="lgTrad.PWD2"
                                    (change)="checkNewPWD('PWD2')"
                                    [ngClass]="{'pwd-OK': classPwdCtrl === 'OK', 'pwd-error': classPwdCtrl === 'ERR'}" />
                                }
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              }
                            </accordion-gala-item-body>
                          </accordion-gala-item>
                          @if (user.TYPEUTIL && user.TYPEUTIL.CODE === 'AGT') {
                            <accordion-gala-item>
                              <accordion-gala-item-head>SIG</accordion-gala-item-head>
                              <accordion-gala-item-body>
                                <div class="row">
                                  <div class="col">
                                    <table class="table">
                                      <thead class="bg-primary">
                                        <tr>
                                          <th colspan="2">{{lgTrad.NAME}}</th>
                                          <th colspan="2">{{lgTrad.AGENTCODE}}</th>
                                          <th colspan="2">{{lgTrad.DEBUT}}</th>
                                          <th colspan="2">{{lgTrad.FIN}}</th>
                                          <th colspan="1"></th>
                                        </tr>
                                      </thead>
                                      @for (o of user.LISTESIG; track o) {
                                        <tbody>
                                          <tr>
                                            <td colspan="2" class="text-left">{{o.COSIG + ' - ' + o.NOMSIG}}</td>
                                            <td colspan="2" class="text-left">{{o.COAGCL}}</td>
                                            <td colspan="2" class="text-left">{{o.DDEBUT | dateFormat}}</td>
                                            <td colspan="2" class="text-left">{{o.DFIN | dateFormat}}</td>
                                            <td colspan="1" class="col-min"></td>
                                          </tr>
                                        </tbody>
                                      }
                                    </table>
                                  </div>
                                </div>
                              </accordion-gala-item-body>
                            </accordion-gala-item>
                          }
                          @if (user.TYPEUTIL && (user.TYPEUTIL.CODE === 'AGT' || user.TYPEUTIL.CODE === 'SAL')) {
                            <accordion-gala-item>
                              <accordion-gala-item-head>{{lgTrad.EMPNFCT}}</accordion-gala-item-head>
                              <accordion-gala-item-body>
                                <div class="row">
                                  <div class="col-12">
                                    <table class="table">
                                      <thead class="bg-primary">
                                        <tr>
                                          <th colspan="1"></th>
                                          <th colspan="2">{{lgTrad.FONCTION}}</th>
                                          <th colspan="2">{{lgTrad.EMPLOYER}}</th>
                                          <th colspan="1">{{lgTrad.ETP}}</th>
                                          <th colspan="1">{{lgTrad.OCTAGRI}}</th>
                                          <th colspan="2">{{lgTrad.DEBUT}}</th>
                                          <th colspan="2">{{lgTrad.FIN}}</th>
                                        </tr>
                                      </thead>
                                      @for (f of user.FONCTIONS; track f) {
                                        <tbody>
                                          <tr>
                                            <td class="text-left">{{typeEmployeurEtFonction[f.PRINCIPAL]}}</td>
                                            <td colspan="2" class="text-left">{{f.FONCTION.FONCTION}}</td>
                                            <td colspan="2" class="text-left">{{(f.ORGANISME)? f.ORGANISME.NOM :
                                            ''}}</td>
                                            <td colspan="1" class="text-left">{{f.ETP}}%</td>
                                            <td colspan="1" class="text-left">{{f.COOCTAGRI}}</td>
                                            <td colspan="2" class="text-left">{{f.DDEBUT | dateFormat}}</td>
                                            <td colspan="2" class="text-left">{{f.DFIN | dateFormat}}</td>
                                          </tr>
                                        </tbody>
                                      }
                                    </table>
                                  </div>
                                </div>
                              </accordion-gala-item-body>
                            </accordion-gala-item>
                          }
                        </accordion-gala>

                        <div gala-dialog-actions>
                          <button mat-stroked-button color="primary" [disabled]="sessionIncarnee" (click)="save()">{{lgTrad.ENREGISTRER}}</button>
                          <button mat-stroked-button color="accent" (click)="hideModal()" cdkFocusInitial>{{lgTrad.RETOUR}}</button>
                        </div>
                      </dialog-gala>